import {
    GET_VENDOR_LOGOUT_REQUEST,
    GET_VENDOR_LOGOUT_SUCCESS,
    VENDOR_SESSION_EXPIRED_REQUEST,
} from "./type";

export const getVendorLogoutRequest = () => {
    return {
        type: GET_VENDOR_LOGOUT_REQUEST,
    };
};

export const getVendorLogoutSuccess = (data) => {
    return {
        type: GET_VENDOR_LOGOUT_SUCCESS,
        payload: data,
    };
};

export const vendorSessionExpiredRequest = () => {
    return {
        type: VENDOR_SESSION_EXPIRED_REQUEST,
    };
};
